export const ADMIN_BASE_PATH = '/admin';

export const toOrganizationSlug = (value: string): string =>
  value.trim().toLowerCase().replace(/\s+/g, '-');

export const adminPaths = {
  base: ADMIN_BASE_PATH,
  /** Canonical org onboarding home (select / resume). */
  onboarding: `${ADMIN_BASE_PATH}/org-onboarding`,
  /** Legacy URL; redirects to onboarding. */
  legacyOnboarding: `${ADMIN_BASE_PATH}/organization/onboarding`,
  /** Organization admin list (refresh-safe; not the onboarding flow URL). */
  organizationDashboard: `${ADMIN_BASE_PATH}/organizations/dashboard`,
  /** Legacy index URL; redirects to organizationDashboard. */
  organizationList: `${ADMIN_BASE_PATH}/organizations`,
  organizationUnits: `${ADMIN_BASE_PATH}/organizations/:orgName/units`,
  /** Canonical unit detail URL; active tab is `?tab=employees` (etc.). */
  organizationUnitDetail: `${ADMIN_BASE_PATH}/organizations/:orgName/units/:unitId`,
  /** Legacy; redirects to organizationUnitDetail with tab=employees. */
  organizationUnitEmployees: `${ADMIN_BASE_PATH}/organizations/:orgName/units/:unitId/employees`,
  signIn: `${ADMIN_BASE_PATH}/sign-in`,
  otpVerification: `${ADMIN_BASE_PATH}/otp-verification`,
  // Legacy paths kept for backward compatibility.
  organization: `${ADMIN_BASE_PATH}/organization`,
  organizationUnit: `${ADMIN_BASE_PATH}/organization/unit`,
  getOrganizationUnitsPath: (orgName: string, orgId?: string): string => {
    const path = `${ADMIN_BASE_PATH}/organizations/${encodeURIComponent(toOrganizationSlug(orgName))}/units`;
    const id = orgId?.trim();
    if (!id) {
      return path;
    }

    return `${path}?orgId=${encodeURIComponent(id)}`;
  },
  getOrganizationUnitDetailPath: (orgName: string, unitId: string): string =>
    `${ADMIN_BASE_PATH}/organizations/${encodeURIComponent(
      toOrganizationSlug(orgName)
    )}/units/${encodeURIComponent(unitId)}`,
  /** @deprecated Use getOrganizationUnitDetailPath + buildUnitDetailSearch tab param. */
  getOrganizationUnitEmployeesPath: (orgName: string, unitId: string): string =>
    `${ADMIN_BASE_PATH}/organizations/${encodeURIComponent(
      toOrganizationSlug(orgName)
    )}/units/${encodeURIComponent(unitId)}/employees`,
  organizationReconnectPayroll: `${ADMIN_BASE_PATH}/organizations/:orgName/units/:unitId/reconnect-payroll`,
  getOrganizationReconnectPayrollPath: (
    orgName: string,
    unitId: string,
    orgId?: string
  ): string => {
    const path = `${ADMIN_BASE_PATH}/organizations/${encodeURIComponent(
      toOrganizationSlug(orgName)
    )}/units/${encodeURIComponent(unitId)}/reconnect-payroll`;
    const id = orgId?.trim();
    if (!id) {
      return path;
    }

    return `${path}?orgId=${encodeURIComponent(id)}`;
  },
  organizationMemberVerificationReview: `${ADMIN_BASE_PATH}/organizations/:orgName/units/:unitId/member-verification/:memberId`,
  getMemberVerificationReviewPath: (orgName: string, unitId: string, memberId: string): string =>
    `${ADMIN_BASE_PATH}/organizations/${encodeURIComponent(
      toOrganizationSlug(orgName)
    )}/units/${encodeURIComponent(unitId)}/member-verification/${encodeURIComponent(memberId)}`,
} as const;
